export const WEBVIEW_USER_AGENT = 'wv';
export const VERSION_USER_AGENT = 'Version/';
export const CHROME_USER_AGENT = 'Chrome/';
export const ANDROID_WEBVIEW_USER_AGENT = 'wv';
export const STANDALONE_USER_AGENT = '(display-mode: standalone)';
